/* Marlovale — cart drawer enhancements (fleet build, on the Impulse/Archetype theme).
   Shipping-protection auto-add + toggle, discount-tier progress bar, custom trash (live-key
   lookup, immune to stale keys once a discount applies), and an "Others also bought" recs slider.
   Reuses Impulse's native ajax cart: qty stepper stays native; our mutations dispatch
   `cart:build` so theme.js re-renders [data-products]+subtotal+count, and we patch the static
   footer (progress + protection toggle + checkout total + recs) ourselves. */
(function () {
  if (window.__marloCart) return;
  window.__marloCart = true;

  var PROTECT = 54064001319253;            // Shipping Protection variant (€2.95 / $3.95 US)
  var PROTECT_PID = 11343703703893;        // Shipping Protection product (never show in recs)
  var OPTOUT = 'marlo_protect_off';
  /* protection disabled for FR + GR (2026-07-05): no toggle, no auto-add; stray lines get removed */
  var NO_PROTECT = false /* FR+GR re-enabled 2026-07-08 */;
  var lock = false;
  var recsKey = '', recsHtml = '';
  var recsWaitTries = 0;
  var selfProtectAdd = false;

  var LANG = (window.Shopify && Shopify.locale ? Shopify.locale.slice(0, 2) : 'fr');
  var I18N = {
    fr: { add1: 'Ajoutez <strong>1 article</strong> pour <strong>{n}% de réduction</strong> !',
          applied: '<strong>{c}% de réduction</strong> appliquée — ajoutez <strong>1 article</strong> pour <strong>{n}%</strong> !',
          max: '🎉 Vous avez débloqué la réduction maximale de <strong>25 %</strong> !',
          intro: 'Achetez plus, économisez plus — jusqu’à <strong>25 % de réduction</strong>',
          off: '% de réduc.', save: 'Économisez', add: '+ Ajouter', others: 'Souvent achetés ensemble' },
    en: { add1: 'Add <strong>1 more</strong> for <strong>{n}% off</strong>!',
          applied: '<strong>{c}% off</strong> applied — add <strong>1 more</strong> for <strong>{n}%</strong>!',
          max: '🎉 You’ve unlocked the maximum <strong>25% off</strong>!',
          intro: 'Buy more, save more — up to <strong>25% off</strong>',
          off: '% off', save: 'Save', add: '+ Add', others: 'Others also bought' },
    es: { add1: 'Añade <strong>1 artículo</strong> y obtén <strong>{n}% de descuento</strong>!',
          applied: '<strong>{c}% de descuento</strong> aplicado — añade <strong>1 artículo</strong> para <strong>{n}%</strong>!',
          max: '🎉 ¡Has desbloqueado el descuento máximo del <strong>25%</strong>!',
          intro: 'Compra más, ahorra más — hasta <strong>25% de descuento</strong>',
          off: '% dto.', save: 'Ahorra', add: '+ Añadir', others: 'También compraron' },
    el: { add1: 'Προσθέστε <strong>1 ακόμα</strong> για <strong>{n}% έκπτωση</strong>!',
          applied: '<strong>{c}% έκπτωση</strong> ενεργή — προσθέστε <strong>1 ακόμα</strong> για <strong>{n}%</strong>!',
          max: '🎉 Ξεκλειδώσατε τη μέγιστη έκπτωση <strong>25%</strong>!',
          intro: 'Αγοράστε περισσότερα, εξοικονομήστε — έως <strong>25% έκπτωση</strong>',
          off: '% έκπτ.', save: 'Κερδίζετε', add: '+ Προσθήκη', others: 'Αγόρασαν επίσης' },
    cs: { add1: 'Přidejte <strong>1 položku</strong> a získejte <strong>{n}% slevu</strong>!',
          applied: '<strong>{c}% sleva</strong> aktivní — přidejte <strong>1 položku</strong> pro <strong>{n}%</strong>!',
          max: '🎉 Odemkli jste maximální slevu <strong>25 %</strong>!',
          intro: 'Kupte více, ušetřete více — až <strong>25% sleva</strong>',
          off: '% sleva', save: 'Ušetříte', add: '+ Přidat', others: 'Často kupováno společně' },
    it: { add1: 'Aggiungi <strong>1 articolo</strong> per <strong>{n}% di sconto</strong>!',
          applied: '<strong>{c}% di sconto</strong> applicato — aggiungi <strong>1 articolo</strong> per <strong>{n}%</strong>!',
          max: '🎉 Hai sbloccato lo sconto massimo del <strong>25%</strong>!',
          intro: 'Compra di più, risparmia di più — fino al <strong>25% di sconto</strong>',
          off: '% sconto', save: 'Risparmia', add: '+ Aggiungi', others: 'Spesso acquistati insieme' }
  };
  var t = I18N[LANG] || I18N.fr;
  var TIERS = [{ q: 2, off: 10 }, { q: 3, off: 15 }, { q: 4, off: 20 }, { q: 5, off: 25 }];

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function getJSON(url) { return fetch(url, { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function money(cents) {
    try { if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) {}
    try { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; return (cents / 100).toLocaleString(Shopify.locale || 'fr', { style: 'currency', currency: cur }); } catch (e2) {}
    return (cents / 100).toFixed(2);
  }
  /* base-currency cents (from /products.json fallback) -> presentment cents */
  function toPresentment(baseCents) {
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    return Math.round(baseCents * rate);
  }
  function rebuild() { document.dispatchEvent(new CustomEvent('cart:build')); }

  /* POST /cart/{add,change}.js WITHOUT a sections param (raw cart json), then let Impulse
     re-render [data-products]+subtotal+count via cart:build, and patch the static footer. */
  function mutate(endpoint, body) {
    return fetch(root() + 'cart/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return getJSON(root() + 'cart.js'); })
      .then(function (cart) { rebuild(); updateStatic(cart); return cart; });
  }

  function hasProtect(cart) { return (cart.items || []).some(function (i) { return i.variant_id === PROTECT; }); }
  function eligibleCount(cart) { return (cart.items || []).reduce(function (n, i) { return n + (i.variant_id === PROTECT ? 0 : i.quantity); }, 0); }
  function optedOut() { try { return localStorage.getItem(OPTOUT) === '1'; } catch (e) { return false; } }
  function protectLine(cart) { return (cart.items || []).filter(function (i) { return i.variant_id === PROTECT; })[0]; }

  function addProtectionMutate() {
    selfProtectAdd = true;
    return mutate('add.js', { items: [{ id: PROTECT, quantity: 1 }] })
      .finally(function () { setTimeout(function () { selfProtectAdd = false; }, 300); });
  }
  function removeProtect() {
    return getJSON(root() + 'cart.js').then(function (cart) {
      var line = protectLine(cart);
      if (!line) return cart;
      return mutate('change.js', { id: line.key, quantity: 0 });
    });
  }

  /* keep protection in sync with the cart: add when there is ≥1 real item and not opted out;
     drop the protection-only leftover when the cart empties; remove on opt-out. */
  function ensureProtect(cart) {
    if (lock) return;
    if (NO_PROTECT) {
      if (hasProtect(cart)) { lock = true; removeProtect().catch(function () {}).finally(function () { lock = false; }); }
      return;
    }
    if (eligibleCount(cart) < 1) {
      if (hasProtect(cart)) { lock = true; removeProtect().catch(function () {}).finally(function () { lock = false; }); }
      return;
    }
    if (optedOut()) { if (hasProtect(cart)) { lock = true; removeProtect().catch(function () {}).finally(function () { lock = false; }); } return; }
    if (hasProtect(cart)) return;
    lock = true;
    addProtectionMutate().catch(function () {}).finally(function () { lock = false; });
  }

  /* ---- static UI patches (footer + top live outside [data-products]) ---- */
  function updateStatic(cart) { updateProgress(cart); updateProtectionToggle(cart); updateTotal(cart); loadRecs(cart); closeIfEmpty(cart); }

  /* auto-close the drawer once the cart is truly empty (no real items + no protection leftover) */
  function closeIfEmpty(cart) {
    if (!cart || cart.item_count) return;
    var open = document.querySelector('#CartDrawer.drawer--is-open') || document.documentElement.classList.contains('js-drawer-open') || document.documentElement.classList.contains('cart-open');
    if (open) setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:close')); }, 240);
  }

  function updateProgress(cart) {
    var wrap = document.querySelector('[data-marlo-progress]');
    if (!wrap) return;
    var q = eligibleCount(cart);
    var reached = 0;
    TIERS.forEach(function (tr) { if (q >= tr.q) reached++; });
    var fill = reached > 0 ? (reached * 25 - 12.5) : 0;
    var msg;
    if (q >= 5) msg = t.max;
    else if (q >= 2) { var cur = TIERS[reached - 1].off, nxt = TIERS[reached].off; msg = t.applied.replace('{c}', cur).replace('{n}', nxt); }
    else if (q === 1) msg = t.add1.replace('{n}', '10');
    else msg = t.intro;
    var m = wrap.querySelector('[data-marlo-progress-msg]'); if (m) m.innerHTML = msg;
    var f = wrap.querySelector('.marlo-prog__fill'); if (f) f.style.width = fill + '%';
    wrap.querySelectorAll('.marlo-prog__node').forEach(function (n, i) { n.classList.toggle('is-on', q >= TIERS[i].q); });
    wrap.querySelectorAll('.marlo-prog__labels span').forEach(function (l, i) { l.classList.toggle('is-on', q >= TIERS[i].q); });
  }

  function updateProtectionToggle(cart) {
    var box = document.querySelector('[data-marlo-protect-toggle]');
    if (box) box.checked = hasProtect(cart);
  }

  function updateTotal(cart) {
    var el = document.querySelector('[data-marlo-total]');
    if (el) el.textContent = money(cart.total_price);
  }

  /* ---- protection toggle ---- */
  document.addEventListener('change', function (e) {
    var tg = e.target.closest ? e.target.closest('[data-marlo-protect-toggle]') : null;
    if (!tg || lock) return;
    lock = true;
    var p;
    if (tg.checked) { try { localStorage.removeItem(OPTOUT); } catch (x) {} p = addProtectionMutate(); }
    else { try { localStorage.setItem(OPTOUT, '1'); } catch (x) {} p = removeProtect(); }
    p.catch(function () {}).finally(function () { lock = false; });
  });

  /* ---- custom trash (live-key lookup; native remove link is a full-page nav) ---- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('[data-marlo-remove]') : null;
    if (!rm || lock) return;
    e.preventDefault();
    var vid = Number(rm.getAttribute('data-marlo-remove'));
    if (!vid) return;
    var li = rm.closest ? rm.closest('.marlo-li') : null;
    function doRemove() {
      getJSON(root() + 'cart.js').then(function (cart) {
        var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
        if (!line) { rebuild(); return null; }
        return mutate('change.js', { id: line.key, quantity: 0 });
      }).then(function (cartAfter) {
        /* drop the protection-only leftover when the last real item is removed */
        if (cartAfter) ensureProtect(cartAfter);
      }).catch(function () {});
    }
    /* smooth collapse + fade before the cart re-renders (Sage-style) */
    if (li) {
      li.style.maxHeight = li.offsetHeight + 'px';
      requestAnimationFrame(function () { requestAnimationFrame(function () { li.classList.add('marlo-li--removing'); }); });
      setTimeout(doRemove, 340);
    } else { doRemove(); }
  });

  /* ---- recommendation + Add ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-marlo-rec-add]') : null;
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-marlo-rec-add');
    var card = add.closest('.marlo-rec');
    var sel = card ? card.querySelector('[data-marlo-rec-variant]') : null;
    if (sel && sel.value) id = sel.value;
    if (!id) return;
    add.setAttribute('disabled', 'true');
    mutate('add.js', { items: [{ id: Number(id), quantity: 1 }] }).catch(function () {}).finally(function () { add.removeAttribute('disabled'); });
  });

  /* ---- slider arrows ---- */
  function recScroll(dir) {
    var list = document.querySelector('[data-marlo-recs-list]');
    if (!list) return;
    var card = list.querySelector('.marlo-rec');
    var w = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.85;
    list.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-marlo-recs-prev]')) { e.preventDefault(); recScroll(-1); }
    else if (e.target.closest && e.target.closest('[data-marlo-recs-next]')) { e.preventDefault(); recScroll(1); }
  });

  function loadRecs(cartArg) {
    var wrap = document.querySelector('[data-marlo-recs]');
    var list = document.querySelector('[data-marlo-recs-list]');
    if (!wrap || !list) return;
    var go = cartArg ? Promise.resolve(cartArg) : getJSON(root() + 'cart.js');
    go.then(function (cart) {
      var items = (cart.items || []).filter(function (i) { return i.variant_id !== PROTECT; });
      if (!items.length) { wrap.hidden = true; return; }
      /* load the recs WITH the cart, not before it: wait until the cart line items are rendered in the drawer */
      if (!document.querySelector('#CartDrawer .marlo-li')) {
        wrap.hidden = true;
        if (recsWaitTries < 25) { recsWaitTries++; setTimeout(function () { loadRecs(cart); }, 120); }
        return;
      }
      recsWaitTries = 0;
      var key = items.map(function (i) { return i.product_id; }).sort().join(',');
      if (key === recsKey && list.children.length) { wrap.hidden = false; return; }
      if (key === recsKey && recsHtml) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
      var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });

      function render(prods) {
        prods = (prods || []).filter(function (p) { return !inCart[p.id] && p.id !== PROTECT_PID && p.available; }).slice(0, 6);
        if (!prods.length) { fallback(); return; }
        var html = '';
        prods.forEach(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var priceHtml = (p.compare_at_price && p.compare_at_price > p.price)
            ? '<span class="marlo-rec__was">' + money(p.compare_at_price) + '</span> <span class="marlo-rec__now">' + money(p.price) + '</span>'
            : '<span class="marlo-rec__now">' + money(p.price) + '</span>';
          var variants = (p.variants || []).filter(function (v) { return v.available; });
          var firstId = variants.length ? variants[0].id : (p.variants && p.variants[0] && p.variants[0].id) || '';
          var sel = '';
          if (variants.length > 1) {
            sel = '<select class="marlo-rec__variant" data-marlo-rec-variant>';
            variants.forEach(function (v) { sel += '<option value="' + v.id + '">' + (v.title || '') + '</option>'; });
            sel += '</select>';
          }
          html += '<div class="marlo-rec">' +
            '<a class="marlo-rec__imgwrap" href="' + p.url + '"><img class="marlo-rec__img" src="' + img + '" alt="" loading="lazy"></a>' +
            '<div class="marlo-rec__body">' +
              '<a class="marlo-rec__title" href="' + p.url + '">' + p.title + '</a>' +
              '<div class="marlo-rec__price">' + priceHtml + '</div>' +
              '<div class="marlo-rec__actions">' + sel +
                '<button type="button" class="marlo-rec__add" data-marlo-rec-add="' + firstId + '">' + t.add + '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        });
        list.innerHTML = html; recsHtml = html; recsKey = key; wrap.hidden = false; enableSwipe(list);
      }
      function fallback() {
        if (recsHtml && key === recsKey) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
        if (list.children.length) { wrap.hidden = false; return; }
        /* last resort: general products */
        getJSON(root() + 'products.json?limit=12').then(function (d) {
          var prods = (d.products || []).map(function (p) {
            /* /products.json prices are in the shop BASE currency — convert to presentment */
            return { id: p.id, title: p.title, url: root() + 'products/' + p.handle, available: p.variants.some(function (v) { return v.available; }),
                     price: toPresentment(Math.round(parseFloat(p.variants[0].price) * 100)),
                     compare_at_price: p.variants[0].compare_at_price ? toPresentment(Math.round(parseFloat(p.variants[0].compare_at_price) * 100)) : null,
                     featured_image: (p.images[0] && p.images[0].src) || '', variants: p.variants };
          });
          var f = prods.filter(function (p) { return !inCart[p.id] && p.id !== PROTECT_PID && p.available; }).slice(0, 6);
          if (f.length) { render(f); } else { wrap.hidden = true; }
        }).catch(function () { wrap.hidden = true; });
      }

      /* try intent=related across cart products until one returns results (some products 404) */
      var idx = 0;
      function tryNext() {
        if (idx >= items.length) { fallback(); return; }
        var pid = items[idx++].product_id;
        getJSON(root() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
          .then(function (data) {
            var prods = (data.products || []).filter(function (p) { return !inCart[p.id] && p.id !== PROTECT_PID && p.available; });
            if (prods.length) render(data.products); else tryNext();
          })
          .catch(function () { tryNext(); });
      }
      tryNext();
    }).catch(function () {});
  }

  function enableSwipe(list) {
    if (list.__marloSwipe) return;
    list.__marloSwipe = true;
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { down = true; moved = false; captured = false; pid = e.pointerId; startX = e.clientX; startScroll = list.scrollLeft; }
    });
    list.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) { moved = true; try { list.setPointerCapture(pid); captured = true; } catch (x) {} }
      if (moved) list.scrollLeft = startScroll - dx;
    });
    function end() { down = false; if (captured) { try { list.releasePointerCapture(pid); } catch (x) {} captured = false; } }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('pointerleave', end);
    list.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ---- sync triggers ---- */
  function syncFromServer() { getJSON(root() + 'cart.js').then(function (c) { ensureProtect(c); updateStatic(c); }).catch(function () {}); }

  function onExternalAdd() {
    try { localStorage.removeItem(OPTOUT); } catch (e) {}
    getJSON(root() + 'cart.js').then(function (cart) {
      if (NO_PROTECT) { ensureProtect(cart); updateStatic(cart); return; }
      if (eligibleCount(cart) >= 1 && !hasProtect(cart) && !lock) {
        lock = true;
        addProtectionMutate().catch(function () {}).finally(function () { lock = false; });
      } else { updateStatic(cart); }
    }).catch(function () {});
  }

  function patchFetch() {
    if (window.__marloFetchPatched || !window.fetch) return;
    window.__marloFetchPatched = true;
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) { p.then(function () { if (!selfProtectAdd) setTimeout(onExternalAdd, 80); }).catch(function () {}); }
      return p;
    };
  }

  function init() {
    patchFetch();
    syncFromServer();
    /* native qty stepper / remove path */
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.item_count === 'number') { ensureProtect(cart); updateStatic(cart); }
      else syncFromServer();
    });
    /* a real product was added (product form / quick add) — Impulse opens+rebuilds the drawer */
    document.addEventListener('ajaxProduct:added', function () { setTimeout(onExternalAdd, 80); });
    /* drawer opened without an add — refresh recs/progress */
    document.addEventListener('drawerOpen.CartDrawer', function () { setTimeout(syncFromServer, 60); });
    document.addEventListener('drawerOpen', function () { setTimeout(syncFromServer, 120); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

